import type { ModuleFile } from '../../core/modules.ts';
export const manifests:ModuleFile['manifests']=[{id:'videos',title:'Vídeos',path:'videos',nav:{group:'Canal',label:'Vídeos',icon:'▶',order:2.5},load:()=>import('./VideosPage.tsx').then(m=>({default:m.VideosPage}))}];
